/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Components State View.
 */

// Redux Actions
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './componentsStateView';

export const mapStateToPropsComponentsStateActions = mapStateToProps;
export const mapDispatchToPropsComponentsStateActions = mapDispatchToProps;

export default connect(
  mapStateToPropsComponentsStateActions,
  mapDispatchToPropsComponentsStateActions
)(View);
